// eslint-disable-next-line import/prefer-default-export
export const capitalize = (s) => {
  if (!s) return '';
  const string = String(s);
  return string.charAt(0).toUpperCase() + string.slice(1);
};
